import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const getOnderpandTextResources = createGetTextResources({
  constructieOmschrijving: `Geef de juiste erfpacht- of kortingsconstructie in wanneer deze niet voorkomt in de keuzelijst, maar wel goedgekeurd is door NHG. Kijk op https://www.nhg.nl/professional/geaccepteerde-erfpacht-en-kortingsconstructies voor de beschikbare constructies.`
});
